import { create } from 'zustand';

type NavbarPanel = 'notifications' | 'team' | 'leaderboard';

interface NavbarPanelsState {
	openPanel: NavbarPanel | null;
	openNotifications: () => void;
	openTeam: () => void;
	openLeaderboard: () => void;
	toggleNotifications: () => void;
	toggleTeam: () => void;
	toggleLeaderboard: () => void;
	closeAll: () => void;
}

export const useNavbarPanelsStore = create<NavbarPanelsState>((set, get) => ({
	openPanel: null,

	openNotifications: () => set({ openPanel: 'notifications' }),
	openTeam: () => set({ openPanel: 'team' }),
	openLeaderboard: () => set({ openPanel: 'leaderboard' }),

	toggleNotifications: () => set({ openPanel: get().openPanel === 'notifications' ? null : 'notifications' }),
	toggleTeam: () => set({ openPanel: get().openPanel === 'team' ? null : 'team' }),
	toggleLeaderboard: () => set({ openPanel: get().openPanel === 'leaderboard' ? null : 'leaderboard' }),

	closeAll: () => set({ openPanel: null }),
}));

// Convenience hooks for specific panels
export const useNavbarPanels = () => useNavbarPanelsStore((state) => state);

export const useNotificationsPanel = () =>
	useNavbarPanelsStore((state) => ({
		isOpen: state.openPanel === 'notifications',
		open: state.openNotifications,
		toggle: state.toggleNotifications,
		close: state.closeAll,
	}));

export const useTeamPanel = () =>
	useNavbarPanelsStore((state) => ({
		isOpen: state.openPanel === 'team',
		open: state.openTeam,
		toggle: state.toggleTeam,
		close: state.closeAll,
	}));

export const useLeaderboardPanel = () =>
	useNavbarPanelsStore((state) => ({
		isOpen: state.openPanel === 'leaderboard',
		open: state.openLeaderboard,
		toggle: state.toggleLeaderboard,
		close: state.closeAll,
	}));

// For closing all panels from nav items
export const useCloseNavbarPanels = () => useNavbarPanelsStore((state) => state.closeAll);
